enum HotKeyScope {
  CANVAS = '画布',
  COMPONENT = '组件',
  LAYOUT = '布局',
  APP = '作品数据',
}

export default HotKeyScope;
